exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.top-banner[data-v-4ba865d0] {\n  width: 100%;\n  background-color: #4f46e5; /* Indigo */\n  color: white;\n  padding: 8px 16px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.banner-text[data-v-4ba865d0] {\n  font-size: 14px;\n  font-weight: 500;\n  margin: 0;\n}\n.banner-link[data-v-4ba865d0] {\n  text-decoration: underline;\n  cursor: pointer;\n}\n.banner-close[data-v-4ba865d0] {\n  position: absolute;\n  right: 12px;\n  background: none;\n  border: none;\n  color: white;\n  font-size: 16px;\n  cursor: pointer;\n}\n.banner-close[data-v-4ba865d0]:hover {\n  color: #ddd;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4ba865d0","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/TopBanner.vue
// module id = 528
// module chunks = 79